var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{class:_vm.start ? 'btn-disabled' : '',attrs:{"type":_vm.type,"disabled":_vm.start,"size":"small"}},[_vm._v("\n    "+_vm._s(_vm.tmpStr)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }